import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { isEmpty } from "lodash";
import loginApi from "../../../apis/login";
import messages from "../../../constants/messages";
import { LoginFormStatus } from "../../../enums";
import authenticationUtils from "../../../utils/authenticationUtils";

interface AuthorizationState {
  authorized: boolean | null;
  status: LoginFormStatus | null;
  errorMessage: string;
}

interface AuthenticateOtpPayload {
  email: string;
  otp: number;
}

const initialState: AuthorizationState = {
  authorized: null,
  status: null,
  errorMessage: "",
};

const authorize = createAsyncThunk(
  "authorize/authorizeUser",
  async (token: string, { rejectWithValue }) => {
    try {
      const response = await loginApi.authenticate(token);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const logoutAdmin = createAsyncThunk("authorize/logoutAdmin", async () => {
  const deviceId = authenticationUtils.getDeviceId();
  if (isEmpty(deviceId)) {
    return true;
  }
});

const authenticateOtp = createAsyncThunk(
  "authenticate/authenticateOtp",
  async (OtpPayload: AuthenticateOtpPayload, { rejectWithValue }) => {
    try {
      const { email, otp } = OtpPayload;
      const response = await loginApi.authenticateOtp(email, otp);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const authorizationSlice = createSlice({
  name: "authorize",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(authorize.fulfilled, (state, action) => {
        const { token } = action.payload.data;
        authenticationUtils.saveToken(token);
      })
      .addCase(authorize.rejected, (state) => {
        state.authorized = false;
      })
      .addCase(authenticateOtp.pending, (state) => {
        state.authorized = false;
        state.status = LoginFormStatus.LOADING;
        state.errorMessage = "";
      })
      .addCase(authenticateOtp.fulfilled, (state, action) => {
        const { token } = action.payload.data;
        authenticationUtils.saveToken(token);
        state.authorized = true;
        state.status = LoginFormStatus.SUCCESS;
        state.errorMessage = "";
      })
      .addCase(authenticateOtp.rejected, (state, action) => {
        const errorMessage = messages.INCORRECT_OTP;
        state.authorized = false;
        state.status = LoginFormStatus.FAILED;
        state.errorMessage = errorMessage;
      });
  },
});

export { authorize, authenticateOtp, logoutAdmin };
export default authorizationSlice;
